export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SingleHeader.vue?vue&type=template&id=1008f142&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SingleHeader.vue?vue&type=template&id=1008f142&scoped=true&
// module id = 332
// module chunks = 0